"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/Application");
var ModalRegisterAppComponent_1 = require("./ModalRegisterAppComponent");
var ModalServiceInApplicationComponent_1 = require("./ModalServiceInApplicationComponent");
var ModalConfirmStatusApplicationComponent_1 = require("./ModalConfirmStatusApplicationComponent");
var reactstrap_1 = require("reactstrap");
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    function Application(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageLoad: true,
            isOpenModalSerInApp: false,
            isOpenModalAccRej: false,
            appUUID: "",
            appName: "",
            typeClick: ""
        };
        _this.BindData = _this.BindData.bind(_this);
        _this.onClickTr = _this.onClickTr.bind(_this);
        _this.afterOpenModalSerInApp = _this.afterOpenModalSerInApp.bind(_this);
        _this.afterCloseModalSerInApp = _this.afterCloseModalSerInApp.bind(_this);
        _this.onClickAccOrRej = _this.onClickAccOrRej.bind(_this);
        _this.afterOpenModalAccRej = _this.afterOpenModalAccRej.bind(_this);
        _this.afterCloseModalAccRej = _this.afterCloseModalAccRej.bind(_this);
        _this.clickEmpty = _this.clickEmpty.bind(_this);
        _this.afterCloseModalRegister = _this.afterCloseModalRegister.bind(_this);
        return _this;
    }
    Application.prototype.componentDidMount = function () {
        this.ensureDataFetched();
    };
    Application.prototype.ensureDataFetched = function () {
        this.props.requestFunction(this.state.pageLoad);
        this.setState({
            pageLoad: false
        });
    };
    Application.prototype.BindData = function () {
        console.log("BindData()");
        this.setState({
            pageLoad: true
        });
        this.ensureDataFetched();
    };
    Application.prototype.onClickTr = function (e) {
        this.setState({
            pageLoad: false,
            isOpenModalSerInApp: true,
            appUUID: e.currentTarget.dataset.appuuid,
            appName: e.currentTarget.dataset.appname
        });
    };
    Application.prototype.afterOpenModalSerInApp = function () {
        this.setState({
            isOpenModalSerInApp: false
        });
    };
    Application.prototype.afterCloseModalSerInApp = function () {
        this.setState({
            pageLoad: true
        });
    };
    Application.prototype.onClickAccOrRej = function (e) {
        this.setState({
            pageLoad: false,
            isOpenModalAccRej: true,
            appUUID: e.target.dataset.appuuid,
            appName: e.target.dataset.appname,
            typeClick: e.target.dataset.typeclick
        });
    };
    Application.prototype.afterOpenModalAccRej = function () {
        this.setState({
            isOpenModalAccRej: false
        });
    };
    Application.prototype.afterCloseModalAccRej = function () {
        this.setState({
            pageLoad: true
        });
    };
    Application.prototype.afterCloseModalRegister = function () {
        this.setState({
            pageLoad: true
        });
    };
    Application.prototype.clickEmpty = function () {
    };
    Application.prototype.render = function () {
        var isOpenModalSerInApp = this.state.isOpenModalSerInApp;
        var isOpenModalAccRej = this.state.isOpenModalAccRej;
        var appUUID = this.state.appUUID;
        var appName = this.state.appName;
        var typeClick = this.state.typeClick;
        return (React.createElement("div", { style: { paddingLeft: 'unset' } },
            React.createElement(ModalRegisterAppComponent_1.default, { BindData: this.BindData.bind(this), afterCloseModalRegister: this.afterCloseModalRegister.bind(this) }),
            React.createElement("hr", null),
            React.createElement("h4", { className: "mb-3", style: { fontWeight: 'bold' } }, "Application"),
            this.props.isLoading && this.renderService(),
            React.createElement(ModalServiceInApplicationComponent_1.default, { afterOpenModal: this.afterOpenModalSerInApp.bind(this), afterCloseModal: this.afterCloseModalSerInApp.bind(this), isOpenModal: isOpenModalSerInApp, appUUID: appUUID, appName: appName }),
            React.createElement(ModalConfirmStatusApplicationComponent_1.default, { afterOpenModal: this.afterOpenModalAccRej.bind(this), afterCloseModal: this.afterCloseModalAccRej.bind(this), isOpenModal: isOpenModalAccRej, appUUID: appUUID, appName: appName, typeClick: typeClick, BindData: this.BindData.bind(this) })));
    };
    Application.prototype.renderService = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("table", { className: 'table table-bordered' },
                React.createElement("thead", null,
                    React.createElement("tr", { style: { background: "rgba(9, 132, 227, 1)", color: "#fff", fontSize: '10pt' } },
                        React.createElement("th", null, "Application UUID"),
                        React.createElement("th", null, "Application Name"),
                        React.createElement("th", null, "Application ID"),
                        React.createElement("th", null, "Email"),
                        React.createElement("th", null, "Status"),
                        React.createElement("th", null, "Created By"),
                        React.createElement("th", null, "Created On"))),
                React.createElement("tbody", null, (this.props.isLoading && this.props.response.result_list != undefined) && this.props.response.result_list.map(function (item) {
                    return React.createElement("tr", { key: item.app_uuid, className: 'table-tbody table-onclick table-tr-' + item.active_status, "data-appuuid": item.app_uuid, "data-appname": item.app_name, onClick: item.active_status == "active" ? _this.onClickTr : _this.clickEmpty },
                        React.createElement("td", null, item.app_uuid),
                        React.createElement("td", null, item.app_name),
                        React.createElement("td", null, item.app_id),
                        React.createElement("td", null, item.email),
                        React.createElement("td", null, item.active_status == "pending" ?
                            React.createElement("div", null,
                                React.createElement(reactstrap_1.Button, { color: "primary", "data-appuuid": item.app_uuid, "data-appname": item.app_name, "data-typeclick": 'Accept', onClick: _this.onClickAccOrRej }, "Accept"),
                                ' ',
                                React.createElement(reactstrap_1.Button, { color: "danger", "data-appuuid": item.app_uuid, "data-appname": item.app_name, "data-typeclick": 'Reject', onClick: _this.onClickAccOrRej }, "Reject"))
                            :
                                item.active_status),
                        React.createElement("td", null, item.created_by),
                        React.createElement("td", null));
                })))));
    };
    return Application;
}(React.Component));
exports.default = react_redux_1.connect(function (state) { return state.application; }, Stores.actionCreators)(Application);
//<td>{moment(item.created_on).format('DD/MMM/YYYY, HH:mm')}</td>
//onClick = { this.onClickTr }
//{ item.active_status == "pending" ? '' : '' }
//<td data-appuuid={item.app_uuid} data-appname={item.app_name}>
//    {item.active_status == "pending" ?
//        <div>
//            <Button color="primary" data-appuuid={item.app_uuid} data-appname={item.app_name} data-typeclick={'Accept'} onClick={this.onClickAccOrRej} >Accept</Button>{' '}
//            <Button color="danger" data-appuuid={item.app_uuid} data-appname={item.app_name} data-typeclick={'Reject'} onClick={this.onClickAccOrRej} >Reject</Button>
//        </div>
//        :
//        item.active_status
//    }
//</td>
//{this.props.isLoading && this.renderService()}
//# sourceMappingURL=Application.js.map